import React from "react";
import { connect } from "react-redux";
import { string } from "prop-types";

import DfpAd from "../../dfp-ad";

const InterstitialAd = ({ pageType, currentPath }) => {
  const adType = `${pageType === "home-page" ? "Haal_Fashion_HP_Int_OOP" : "Haal_Fashion_New_Int_OOP"}`;
  const slotID = `${adType} - ${currentPath}`;
  return <DfpAd layoutName="InterstitialAd" slotId={slotID} adtype={adType} />;
};

InterstitialAd.propTypes = {
  pageType: string,
};

const mapStateToProps = (state) => ({
  pageType: state.qt.pageType,
  currentPath: state?.qt?.currentPath,
});

export default connect(mapStateToProps)(InterstitialAd);
